var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharacterHeadIndividual6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 146 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#9e5031;}.cls-3,.cls-4,.cls-5,.cls-6{fill-rule:evenodd;}.cls-4{fill:#804026;}.cls-5{fill:#424f54;}.cls-6,.cls-7{fill:#222c30;}.cls-8{fill:#de3232;}.cls-9{fill:#f76161;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 142,
    height: 115
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.59,74.94a8.12,8.12,0,1,0,8.12,8.12,8.12,8.12,0,0,0-8.12-8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.59,79a4.06,4.06,0,1,0,4.06,4.06A4.06,4.06,0,0,0,114.59,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.29,83.06a8.12,8.12,0,1,0,8.12-8.12h0a8.11,8.11,0,0,0-8.12,8.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.41,79a4.06,4.06,0,1,0,4.06,4.06A4.06,4.06,0,0,0,33.41,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.06,26.23a40.38,40.38,0,0,1,40.21,40.59v40.59a40.21,40.21,0,1,1-80.42,0V66.82A40.39,40.39,0,0,1,75.06,26.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74,48.54H53.91c-2.24,0-4.16-.24-5.74-1.82l-5.74-5.84a4,4,0,0,1,0-5.68A44.49,44.49,0,0,1,74,22.15l8.11,13.19L74,48.54ZM41.53,69.39a2.21,2.21,0,0,0,2-2.24,2.11,2.11,0,0,0-2-2.13l-8.12,0a2.22,2.22,0,0,0,0,4.42Zm.58-8.91a2,2,0,0,0,2.48-1.43,2,2,0,0,0-1.43-2.48l-7.84-2.1a2,2,0,0,0-1,3.91l7.84,2.1Zm2.76-8a2,2,0,1,0,2-3.5l-7-4.06a2,2,0,0,0-2,3.5l7,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.29,73.59a2,2,0,0,1-3,2.7,10.16,10.16,0,0,0-15.13,0,2,2,0,1,1-3-2.7,14.19,14.19,0,0,1,21.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.88,73.59a2,2,0,0,1-3,2.7,10.17,10.17,0,0,0-15.14,0,2,2,0,1,1-3-2.7,14.19,14.19,0,0,1,21.17,0ZM73.57,48.54V22.17a44.21,44.21,0,0,1,31.78,13.08,4.05,4.05,0,0,1,.11,5.74l-5.69,5.73c-1.58,1.58-3.44,1.82-5.68,1.82Zm32.9,16.38a2.25,2.25,0,0,0,0,4.47h8.12a2.22,2.22,0,0,0,2-2.24,2.12,2.12,0,0,0-2-2.13l-8.12-.1Zm-1.63-8.35a2,2,0,0,0,1,3.91l7.83-2.1a2,2,0,1,0-1-3.91l-7.84,2.1ZM101.11,49a2,2,0,0,0,2,3.5l7-4.06a2,2,0,0,0-2-3.5l-7,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M53.7,79a4.06,4.06,0,1,1-4.06,4.06A4.06,4.06,0,0,1,53.7,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.3,79a4.06,4.06,0,1,1-4.06,4.06A4,4,0,0,1,94.3,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M90.24,78.32c-3.35,0-6.1,2.07-6.1,5.42a10.81,10.81,0,0,0,11.1,10.81,11.39,11.39,0,0,0,11.09-11.49V78.32ZM74,77l-2-2,2-2a9.88,9.88,0,0,1,8.12,3.79,10.42,10.42,0,0,1,8.12-4.33h26.38a2.27,2.27,0,0,1,2,2.29c0,1.12-1.52,2.16-2.63,2.16l-6.7.14v6.1c0,8.4-6.2,15.22-14.61,15.22A15,15,0,0,1,79.78,83.06,5.84,5.84,0,0,0,74,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M73.57,77S67.7,79.7,67.7,83.06a14.94,14.94,0,1,1-29.87,0V77H31.56a2.35,2.35,0,0,1-2.11-2.3,2.19,2.19,0,0,1,1.93-2.29H57.76a10,10,0,0,1,7.9,4.33,9.79,9.79,0,0,1,7.91-3.79V77ZM57.76,78.32H40.81v4.74A11.48,11.48,0,0,0,52.33,94.22c6.16,0,11.34-4.32,11.34-10.48,0-3.35-2.56-5.42-5.91-5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.63,94.26,77.35,84.1a2.53,2.53,0,1,0-5.06.14h0l.21,7.62L70,91.94a7.62,7.62,0,1,0,.42,15.24l5.08-.15a2.53,2.53,0,0,0,2.46-2.6Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterHeadIndividual6);
export default __webpack_public_path__ + "static/media/character-head-individual-6.c9b3a4f81ba8c7e9df01ee4b6b7f9e3d.svg";
export { ForwardRef as ReactComponent };